<template>
  <div class="contact-form">
    <form @submit.prevent="submitForm">
      <div>

        <v-text-field
          v-model="name"
          label="Jméno"
          outlined
          color="#2e4db9"
          :error-messages="getViolation('name')"
        ></v-text-field>

        <v-text-field
          v-model="email"
          label="E-mail"
          outlined
          color="#2e4db9"
          :error-messages="getViolation('email')"
        ></v-text-field>

        <v-text-field
          v-model="phone"
          label="Telefon"
          outlined
          color="#2e4db9"
          :error-messages="getViolation('phone')"
        ></v-text-field>
      </div>
      <div>

        <v-textarea
          v-model="message"
          outlined
          label="Zpráva"
          color="#2e4db9"
          :error-messages="getViolation('message')"
        ></v-textarea>
      </div>
      <!-- Honeypot: off-screen, real visitors never fill it, bots that fill every input do. -->
      <div style="position: absolute; left: -9999px; top: -9999px;" aria-hidden="true">
        <label>Website <input v-model="website" type="text" name="website" tabindex="-1" autocomplete="off"></label>
      </div>
      <div>
        <v-btn
          :loading="loading"
          :disabled="loading"
          type="submit"
          color="#2e4db9"
          class="white--text"
          elevation="0"
          rounded
          x-large
        >Odeslat</v-btn>
      </div>
    </form>
    <div class="people-blocks">
      <article>
        <h3>Dušan</h3>
        <ul class="contacts people">
          <li>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="far"
              data-icon="mobile"
              class="svg-inline--fa fa-mobile fa-w-10"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path
                fill="currentColor"
                d="M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zM320 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6z"
              ></path>
            </svg>
            <a href="tel:00420778595757">+420 778 595 757</a>
          </li>
          <li>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fal"
              data-icon="envelope"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              class="svg-inline--fa fa-envelope fa-w-16"
            >
              <path
                fill="currentColor"
                d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z"
              ></path>
            </svg>
            <a href="mailto:dusan@barrelka.cz">dusan@barrelka.cz</a>
          </li>
        </ul>
      </article>
      <article>
        <h3>Anna</h3>
        <ul class="contacts people">
          <li>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="far"
              data-icon="mobile"
              class="svg-inline--fa fa-mobile fa-w-10"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path
                fill="currentColor"
                d="M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zM320 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6z"
              ></path>
            </svg>
            <a href="tel:00420736110872">+420 736 110 872</a>
          </li>
          <li>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fal"
              data-icon="envelope"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              class="svg-inline--fa fa-envelope fa-w-16"
            >
              <path
                fill="currentColor"
                d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z"
              ></path>
            </svg>
            <a href="mailto:anna@barrelka.cz">anna@barrelka.cz</a>
          </li>
        </ul>
      </article>
      <article>
        <h3>Matúš</h3>
        <ul class="contacts people">
          <li>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="far"
              data-icon="mobile"
              class="svg-inline--fa fa-mobile fa-w-10"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path
                fill="currentColor"
                d="M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zM320 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6z"
              ></path>
            </svg>
            <a href="tel:00420605285681">+420 605 285 681</a>
          </li>
          <li>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fal"
              data-icon="envelope"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              class="svg-inline--fa fa-envelope fa-w-16"
            >
              <path
                fill="currentColor"
                d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z"
              ></path>
            </svg>
            <a href="mailto:matus@barrelka.cz">matus@barrelka.cz</a>
          </li>
        </ul>
      </article>
    </div>
  </div>
</template>

<script>
import Axios from '../ajax'
import Qs from 'qs'
import { errorMixin } from '../mixins/error-mixin'

export default {
  name: 'VContactForm',
  mixins: [
    errorMixin
  ],
  data () {
    return {
      name: '',
      email: '',
      phone: '',
      message: '',
      website: '',
      loading: false
    }
  },
  methods: {
    async submitForm () {
      // A second click or Enter while the request runs would send a duplicate inquiry.
      if (this.loading) return
      this.clearViolations()
      this.loading = true
      try {
        const response = await Axios.post('/contact', Qs.stringify({
          name: this.name,
          email: this.email,
          phone: this.phone,
          message: this.message,
          website: this.website
        }))

        this.name = ''
        this.email = ''
        this.phone = ''
        this.message = ''

      } catch (error) {
        this.buildViolations(error.response)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
